import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  property: null,
  lightBox: {
    quality: '2048x1600',
    visible: false,
    index: 0
  },
  searchActivityStatuses: null,
  searchActivityMonths: 6,
  searchMapForeclosure: false,
  taxDetailMapStatusFiltersVisible: false,
  taxDetailMapForeclosure: false,
  taxDetailActivityStatuses: null,
  taxDetailActivityMonths: 6,
  taxDetailActivityForSaleRent: 'Any',
  taxDetailMapFiltersChanged: null,
  mapLegendControlVisible: false,
  parcel: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ACTIVE_PROPERTY_ID:
      return {
        ...state,
        property: action.property
      }
    case actionTypes.TOGGLE_PROPERTY_ADDRESS_WITHHELD:
      return {
        ...state,
        addressWithheld: action.bool
      }
    case actionTypes.TOGGLE_LIGHTBOX:
      return {
        ...state,
        lightBox: {
          ...state.lightBox,
          ...action.toggle
        }
      }
    case actionTypes.SET_MAP_LEGEND_VISIBLE:
      return {
        ...state,
        mapLegendControlVisible: action.bool
      }
    case actionTypes.TOGGLE_SEARCH_PROPERTY_STATUS:
      return {
        ...state,
        searchPropertyStatuses: state.searchPropertyStatuses.map(status => {
          if (status.display !== action.display) {
            return status
          }
          return { ...status, selected: !status.selected }
        })
      }
    case actionTypes.TOGGLE_TAX_DETAIL_PROPERTY_STATUS:
      return {
        ...state,
        taxDetailActivityStatuses: state.taxDetailActivityStatuses.map(
          status => {
            if (status.display !== action.display) {
              return status
            }
            return { ...status, selected: !status.selected }
          }
        )
      }
    case actionTypes.TOGGLE_TAX_DETAIL_PROPERTY_STATUS_SELECT_ALL:
      return {
        ...state,
        taxDetailActivityStatuses: state.taxDetailActivityStatuses.map(
          status => ({ ...status, selected: true })
        ),
        taxDetailMapForeclosure: true
      }
    case actionTypes.TOGGLE_TAX_DETAIL_PROPERTY_STATUS_DESELECT_ALL:
      return {
        ...state,
        taxDetailActivityStatuses: state.taxDetailActivityStatuses.map(
          status => ({ ...status, selected: false })
        ),
        taxDetailMapForeclosure: false
      }
    case actionTypes.SET_TAX_DETAIL_MAP_STATUS_FILTERS_VISIBLE:
      return {
        ...state,
        taxDetailMapStatusFiltersVisible: action.bool
      }
    case actionTypes.SET_TAX_DETAIL_ACTIVITY_STATUSES:
      return {
        ...state,
        taxDetailActivityStatuses: action.taxDetailActivityStatuses
      }
    case actionTypes.SET_TAX_DETAIL_ACTIVITY_MONTHS:
      return {
        ...state,
        taxDetailActivityMonths: action.months
      }
    case actionTypes.SET_TAX_DETAIL_ACTIVITY_FORSALE_RENT:
      return {
        ...state,
        taxDetailActivityForSaleRent: action.value
      }
    case actionTypes.SET_TAX_DETAIL_MAP_FILTERS_CHANGED:
      return {
        ...state,
        taxDetailMapFiltersChanged: action.bool
      }
    case actionTypes.RESET_TAX_DETAIL_MAP_FILTERS:
      return {
        ...state,
        taxDetailMapStatusFiltersVisible:
          initialState.taxDetailMapStatusFiltersVisible,
        taxDetailActivityStatuses: initialState.taxDetailActivityStatuses,
        taxDetailActivityMonths: initialState.taxDetailActivityMonths,
        taxDetailActivityForSaleRent: initialState.taxDetailActivityForSaleRent,
        taxDetailMapFiltersChanged: initialState.taxDetailMapFiltersChanged,
        taxDetailMapForeclosure: initialState.taxDetailMapForeclosure
      }
    case actionTypes.SET_PARCEL:
      return {
        ...state,
        parcel: action.parcel
      }
    case actionTypes.TOGGLE_TAX_DETAIL_MAP_FORECLOSURE:
      return {
        ...state,
        taxDetailMapForeclosure: !state.taxDetailMapForeclosure
      }
    case actionTypes.SET_SEARCH_ACTIVITY_STATUSES:
      return {
        ...state,
        searchActivityStatuses: action.searchActivityStatuses
      }
    default:
      return state
  }
}

export default reducer
